import { render, staticRenderFns } from "./wxUser.vue?vue&type=template&id=4e9f7f26"
import script from "./wxUser.vue?vue&type=script&lang=js"
export * from "./wxUser.vue?vue&type=script&lang=js"
import style0 from "./wxUser.vue?vue&type=style&index=0&id=4e9f7f26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports